import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ICompanyDetailsState, LoadedDocumentsPayloadType, LoadFilePayloadType } from "./types";
import { DictionariesCompanyModel } from "../../../../viewModels/Dictionaries/DictionariesCompanyModel";
import { ChangePasswordInputModel } from "../../../../viewModels/Auth/ChangePasswordInputModel";
import { FormErrorModel } from "../../../../viewModels/General/ErrorModel";
import { CompaniesTabs } from "..";

const initialState: ICompanyDetailsState = {
  loading: true,
  loadingData: true,

  activeCompanyTabId: undefined!,

  changePasswordFormErrors: undefined!,

  companyDetails: undefined!,

  pageSize: 10,
  page: 1,
  total: undefined!,

  isFileModalOpen: false,
  isFileLoading: false,
  file: undefined!,
  filename: "",
  typeId: 0,

  documents: undefined!,

  documentsPageSize: 10,
  documentsPage: 1,
  documentsTotal: undefined!,
};

const companyDetailsSlice = createSlice({
  name: "companyDetailsPage",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
      state.loadingData = action.payload;
    },

    loadCompanyDetails(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    loadCompanyDetailsSuccess(state, action: PayloadAction<DictionariesCompanyModel>) {
      state.loading = false;
      state.loadingData = false;
      state.companyDetails = action.payload;
    },
    loadApplicationDetailsError() {},
    resetCompanyDetails(state) {
      state.companyDetails = undefined!;
      state.activeCompanyTabId = undefined!;
    },

    createCompany(state, _action: PayloadAction<any>) {
      state.loadingData = true;
    },
    createCompanySuccess(state) {
      state.loadingData = false;
    },
    createCompanyError(state) {
      state.loadingData = false;
    },

    updateCompany(state, _action: PayloadAction<any>) {
      state.loadingData = true;
    },
    updateCompanySuccess(state) {
      state.loadingData = false;
    },
    updateCompanyError(state) {
      state.loadingData = false;
    },

    changeActiveCompanyTabId(state, action: PayloadAction<CompaniesTabs>) {
      state.activeCompanyTabId = action.payload;
    },

    changePassword(state, _action: PayloadAction<ChangePasswordInputModel>) {
      state.loadingData = true;
    },
    changePasswordSuccess(state) {
      state.loadingData = false;
    },
    changePasswordError(state, action: PayloadAction<Array<FormErrorModel>>) {
      state.changePasswordFormErrors = action.payload;
      state.loadingData = false;
    },

    loadDocuments(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    loadDocumentsSuccess(state, action: PayloadAction<LoadedDocumentsPayloadType>) {
      const { documents, page, pageSize, total } = action.payload;
      state.loadingData = false;
      state.documents = documents;
      state.documentsPage = page;
      state.documentsPageSize = pageSize;
      state.documentsTotal = total;
      state.isFileLoading = false;
      state.isFileModalOpen = false;
      state.file = undefined!;
      state.filename = "";
      state.typeId = 0;
    },
    loadDocumentsError(state) {
      state.loadingData = false;
    },
    openFileModal(state) {
      state.isFileModalOpen = true;
    },
    closeFileModal(state) {
      state.isFileModalOpen = false;
    },
    uploadDocument(state, action: PayloadAction<LoadFilePayloadType>) {
      const { file, filename, typeId } = action.payload;
      state.isFileLoading = true;
      state.file = file;
      state.filename = filename;
      state.typeId = typeId;
    },
    uploadDocumnetError(state) {
      state.isFileLoading = false;
    },

    downloadDocument(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    downloadDocumentSuccess(state) {
      state.loadingData = false;
    },
    downloadDocumentError(state) {
      state.loadingData = false;
    },

    changeDocumentsPagination(state, action: PayloadAction<{ page: number; pageSize: number; id: number }>) {
      state.documentsPageSize = action.payload.pageSize;
      state.documentsPage = action.payload.page;
      state.loadingData = true;
    },

    deleteDocument(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    deleteDocumentError(state) {
      state.loadingData = false;
    },
  },
});

export default companyDetailsSlice;
